import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  :root {
  --background: 220 18% 10%;
  --foreground: 0 0% 98%;

  --card: 220 18% 12%;
  --card-foreground: 0 0% 98%;

  --popover: 220 20% 10%;
  --popover-foreground: 210 20% 92%;

  --primary: 25 95% 53%;
  --primary-foreground: 0 0% 100%;

  --secondary: 220 15% 16%;
  --secondary-foreground: 210 20% 88%;

  --muted: 220 15% 16%;
  --muted-foreground: 215 20% 65%;

  --accent: 190 90% 50%;
  --accent-foreground: 0 0% 100%;

  --destructive: 0 84% 60%;
  --destructive-foreground: 0 0% 100%;

  --border: 220 15% 18%;
  --input: 220 15% 18%;
  --ring: 25 95% 53%;

  --radius: 0.75rem;

  --warm: 25 95% 53%;
  --success: 160 60% 45%;
  --neon-cyan: 190 90% 50%;
  --neon-orange: 25 95% 53%;
  --neon-pink: 330 85% 60%;
  --sky: 190 90% 50%;
}

body[data-theme='light'] {
  --background: 210 38% 96%;
  --foreground: 222 47% 11%;

  --card: 210 45% 98%;
  --card-foreground: 222 47% 11%;

  --popover: 0 0% 100%;
  --popover-foreground: 222 47% 11%;

  --primary: 25 95% 53%;
  --primary-foreground: 0 0% 100%;

  --secondary: 210 32% 94%;
  --secondary-foreground: 222 30% 18%;

  --muted: 210 28% 94%;
  --muted-foreground: 215 16% 40%;

  --accent: 196 86% 48%;
  --accent-foreground: 0 0% 100%;

  --destructive: 0 84% 60%;
  --destructive-foreground: 0 0% 100%;

  --border: 214 24% 86%;
  --input: 214 24% 86%;
  --ring: 25 95% 53%;

  --warm: 25 95% 53%;
  --success: 160 54% 42%;
  --neon-cyan: 196 86% 48%;
  --neon-orange: 25 95% 53%;
  --neon-pink: 330 75% 58%;
  --sky: 196 86% 48%;
}

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    border-color: hsl(var(--border));
  }

  html, body, #root {
    height: 100%;
  }

  body {
  -webkit-font-smoothing: antialiased;
  font-family: 'Nunito', 'Nunito Fallback', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-size: 16px;
  color: hsl(var(--foreground));
  background-color: hsl(var(--background));

  background-image:
    radial-gradient(circle at top left, hsl(var(--primary) / 0.045), transparent 28%),
    radial-gradient(circle at top right, hsl(var(--accent) / 0.055), transparent 30%),
    linear-gradient(hsl(var(--foreground) / 0.04) 1px, transparent 1px),
    linear-gradient(90deg, hsl(var(--foreground) / 0.04) 1px, transparent 1px);
  background-size:
    auto,
    auto,
    60px 60px,
    60px 60px;

  transition:
    background-color 0.25s ease,
    color 0.25s ease,
    background-image 0.25s ease;
}

  .container {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  @media (max-width: 768px) {
    .container {
      padding: 0 1rem;
    }
  }

  /* Floating particles overlay */
  body::before {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(2px 2px at 20% 30%, hsl(var(--accent) / 0.18), transparent),
    radial-gradient(2px 2px at 40% 70%, hsl(var(--primary) / 0.14), transparent),
    radial-gradient(1px 1px at 60% 20%, hsl(var(--accent) / 0.2), transparent),
    radial-gradient(1px 1px at 80% 50%, hsl(var(--primary) / 0.16), transparent),
    radial-gradient(2px 2px at 10% 80%, hsl(var(--neon-pink) / 0.12), transparent),
    radial-gradient(1px 1px at 70% 90%, hsl(var(--accent) / 0.16), transparent),
    radial-gradient(1px 1px at 90% 10%, hsl(var(--primary) / 0.2), transparent);
  animation: particles-float 20s ease-in-out infinite;
}

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Quicksand', 'Quicksand Fallback', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 600;
  }

  h1 {
    font-size: 2.2em;
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  a {
    color: inherit;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
  background: hsl(var(--background));
}
::-webkit-scrollbar-thumb {
  background: hsl(var(--primary) / 0.35);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: hsl(var(--primary) / 0.55);
}

  .glass {
  background: hsl(var(--card) / 0.72);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid hsl(var(--foreground) / 0.08);
}

.glass-strong {
  background: hsl(var(--card) / 0.86);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border: 1px solid hsl(var(--foreground) / 0.1);
}

body[data-theme='light'] .glass {
  background:
    linear-gradient(
      135deg,
      hsl(var(--primary) / 0.045),
      transparent 30%,
      hsl(var(--accent) / 0.05)
    ),
    hsl(var(--card) / 0.88);
  border: 1px solid hsl(var(--foreground) / 0.06);
  box-shadow:
    0 14px 34px hsl(215 30% 20% / 0.06),
    inset 0 1px 0 hsl(0 0% 100% / 0.45);
}

body[data-theme='light'] .glass-strong {
  background:
    linear-gradient(
      135deg,
      hsl(var(--primary) / 0.06),
      transparent 34%,
      hsl(var(--accent) / 0.065)
    ),
    hsl(var(--card) / 0.94);
  border: 1px solid hsl(var(--foreground) / 0.06);
  box-shadow:
    0 18px 42px hsl(215 30% 20% / 0.08),
    inset 0 1px 0 hsl(0 0% 100% / 0.55);
}

  .glow-primary {
    box-shadow: 0 0 15px hsl(var(--primary) / 0.3),
                0 0 45px hsl(var(--primary) / 0.1);
  }

  .glow-sky {
    box-shadow: 0 0 15px hsl(var(--accent) / 0.3),
                0 0 45px hsl(var(--accent) / 0.1);
  }

  .neon-line {
    height: 2px;
    background: linear-gradient(
      90deg,
      transparent,
      hsl(var(--neon-cyan)),
      hsl(var(--neon-orange)),
      hsl(var(--neon-cyan)),
      transparent
    );
    opacity: 0.6;
  }

  .hover-scale {
    transition: transform 200ms ease;
  }
  .hover-scale:hover {
    transform: scale(1.05);
  }

  .text-gradient-primary {
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    background-image: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--warm)));
  }

  .text-gradient-sky {
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    background-image: linear-gradient(90deg, hsl(var(--accent)), hsl(var(--accent)));
  }

  .text-gradient-mixed {
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    background-image: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--warm)), hsl(var(--accent)));
  }

  .text-gradient-neon {
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    background-image: linear-gradient(135deg, hsl(var(--neon-cyan)), hsl(var(--neon-orange)), hsl(var(--neon-pink)));
  }

  .glow-text-primary {
    text-shadow: 0 0 10px hsl(var(--primary) / 0.5), 0 0 30px hsl(var(--primary) / 0.2);
  }
  .glow-text-sky {
    text-shadow: 0 0 10px hsl(var(--accent) / 0.5), 0 0 30px hsl(var(--accent) / 0.2);
  }

  .particles-bg {
    position: relative;
    overflow: hidden;
  }
  .particles-bg::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(2px 2px at 20% 30%, hsl(var(--accent) / 0.3), transparent),
      radial-gradient(2px 2px at 40% 70%, hsl(var(--primary) / 0.2), transparent),
      radial-gradient(1px 1px at 60% 20%, hsl(var(--accent) / 0.4), transparent),
      radial-gradient(1px 1px at 80% 50%, hsl(var(--primary) / 0.3), transparent),
      radial-gradient(2px 2px at 10% 80%, hsl(var(--neon-pink) / 0.2), transparent),
      radial-gradient(1px 1px at 70% 90%, hsl(var(--accent) / 0.3), transparent),
      radial-gradient(1px 1px at 90% 10%, hsl(var(--primary) / 0.4), transparent);
    pointer-events: none;
    animation: particles-float 20s ease-in-out infinite;
  }

  .grid-bg {
    background-image:
      linear-gradient(hsl(var(--foreground) / 0.03) 1px, transparent 1px),
      linear-gradient(90deg, hsl(var(--foreground) / 0.03) 1px, transparent 1px);
    background-size: 60px 60px;
  }

  .animated-border {
    position: relative;
    overflow: hidden;
  }

  .animated-border::before {
    content: '';
    position: absolute;
    inset: -2px;
    background: conic-gradient(
      from var(--border-angle, 0deg),
      hsl(var(--neon-cyan)),
      hsl(var(--neon-orange)),
      hsl(var(--neon-pink)),
      hsl(var(--neon-cyan))
    );
    border-radius: inherit;
    z-index: -1;
    animation: border-rotate 4s linear infinite;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  .animated-border:hover::before {
    opacity: 1;
  }

  .animated-border::after {
    content: '';
    position: absolute;
    inset: 1px;
    background: hsl(var(--card));
    border-radius: inherit;
    z-index: -1;
  }

  @keyframes border-rotate {
    0% { --border-angle: 0deg; }
    100% { --border-angle: 360deg; }
  }

  @keyframes particles-float {
    0%, 100% { transform: translateY(0) translateX(0); }
    25% { transform: translateY(-20px) translateX(10px); }
    50% { transform: translateY(-10px) translateX(-10px); }
    75% { transform: translateY(-30px) translateX(5px); }
  }

  /* Register custom property for border animation (supported browsers only)*/
  @property --border-angle {
    syntax: "<angle>";
    inherits: false;
    initial-value: 0deg;
  }
`;
